export interface TradeLinks {
  steam?: string;
  vgo?: string;
}
